/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { ComponentProps } from 'react';

import { breakpoints } from '@coursera/cds-core';

import ComplexCollectionRenderer from 'bundles/browse-common/renderers/ComplexCollectionRenderer/ComplexCollectionRenderer';
import CollectionModuleRenderer from 'bundles/page-config-common/module-renderers/CollectionModuleRenderer';

const styles = {
  complexCollection: css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      margin-bottom: var(--cds-spacing-300);
    }

    section {
      padding-top: var(--cds-spacing-150);
      padding-bottom: 0;
    }

    div:nth-of-type(2) > div {
      padding-top: 0;
      padding-bottom: 0;

      & > div {
        margin-top: 0;
        margin-bottom: 0;

        & > div:nth-of-type(1) {
          padding-top: 0;
        }

        & > div:nth-of-type(2) {
          padding-bottom: 0;
        }
      }
    }
  `,
  simpleCollection: css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      margin-bottom: var(--cds-spacing-300);
    }

    section {
      padding-top: 0;
      padding-bottom: 0;
    }

    & > div > div > div {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 0;
      padding-bottom: 0;

      & > div > div {
        margin-top: 0;
        margin-bottom: 0;

        & > div {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
    }
  `,
};

type Props = ComponentProps<typeof CollectionModuleRenderer>;

const AnyCollectionRenderer = (props: Props) => {
  const { pageConfigComponent } = props;

  const isComplexCollection =
    pageConfigComponent.collectionEntity.__typename === 'Recommendation_Collection' &&
    pageConfigComponent.collectionEntity.entities?.elements?.every(
      (elem) => elem?.__typename === 'Recommendation_Collection'
    );

  if (isComplexCollection) {
    return (
      <div css={styles.complexCollection}>
        <ComplexCollectionRenderer pageConfig={pageConfigComponent} />
      </div>
    );
  }

  return (
    <div css={styles.simpleCollection}>
      <CollectionModuleRenderer {...props} spacing={0} headerTypographyVariant="subtitleLarge" />
    </div>
  );
};

export default AnyCollectionRenderer;
